module.exports = __webpack_public_path__ + "img/vertical_3_2_8003.b1460cdd.png";